import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { Icons } from '../../util/Icons';
import { fadeInUp400ms } from '../../../@vex/animations/fade-in-up.animation';
import { stagger40ms } from '../../../@vex/animations/stagger.animation';
import { SessionService } from '../../services/session.service';
import { LayoutService } from '../../../@vex/services/layout.service';
import { BreadCrumbService } from '../../../@vex/components/breadcrumbs/BreadCrumbService';
import { TranslocoDirective } from '@jsverse/transloco';
import { PageLayoutComponent } from '../../../@vex/components/page-layout/page-layout.component';
import { PageLayoutHeaderDirective } from '../../../@vex/components/page-layout/page-layout-header.directive';
import { BreadcrumbsComponent } from '../../../@vex/components/breadcrumbs/breadcrumbs.component';
import { PageLayoutContentDirective } from '../../../@vex/components/page-layout/page-layout-content.directive';
import { MatTabGroup, MatTab, MatTabContent } from '@angular/material/tabs';
import { UviLetterSettingsComponent } from '../uvi-letter-settings/uvi-letter-settings.component';
import { DocumentTransferSettingsComponent } from './document-transfer-settings/document-transfer-settings.component';
import { DevSettingsComponent } from './dev-settings/dev-settings.component';

@Component({
	selector: 'ara-settings',
	templateUrl: './settings.component.html',
	styleUrls: ['./settings.component.scss'],
	animations: [fadeInUp400ms, stagger40ms],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		TranslocoDirective,
		PageLayoutComponent,
		PageLayoutHeaderDirective,
		BreadcrumbsComponent,
		PageLayoutContentDirective,
		MatTabGroup,
		MatTab,
		MatTabContent,
		UviLetterSettingsComponent,
		DocumentTransferSettingsComponent,
		DevSettingsComponent,
	],
})
export class SettingsComponent implements OnInit {
	private themeService = inject(ThemeService);
	private layoutService = inject(LayoutService);
	sessionService = inject(SessionService);
	icons = inject(Icons);
	breadCrumbService = inject(BreadCrumbService);

	darkTheme: boolean = this.themeService.getThemeAsString() === 'dark';
	isMobile = false;
	currentArea: number;

	constructor() {
		const layoutService = this.layoutService;

		this.isMobile = layoutService.isMobile();
	}

	ngOnInit(): void {
		this.currentArea = this.sessionService.effectiveArea;
		sessionStorage.setItem('activeView', window.location.href);

		this.breadCrumbService.reset();
		this.breadCrumbService.addBreadCrumb({
			translationKey: 'settings.settings',
			icon: this.icons.get('settings'),
		});
	}

	public toggleTheme(event: any) {
		if (event.checked) {
			this.themeService.setTheme('dark');
			sessionStorage.setItem('theme', 'dark');
			this.darkTheme = true;
		} else {
			this.themeService.setTheme('light');
			sessionStorage.setItem('theme', 'light');
			this.darkTheme = false;
		}
	}
}
